import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from 'src/routes';
import { useAuth } from './auth/AuthContext';

export const RouteWithAuth = ({ children }: { children: React.ReactNode }) => {
  const { user, loaded } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loaded) return;
    if (!user) {
      navigate(ROUTES.HOME, { replace: true, state: { from: location } });
    }
  }, [user, loaded, navigate, location]);

  if (!loaded) {
    return null;
  }

  return <div className="route-with-auth">{!!user && children}</div>;
};
